import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {useThemeNumericBreakpoints} from "@pg-design/themes";
import {navigationLinks} from "@pg-rp/navigation";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {companyLogos} from "../constants/company_logos";

const {propertyGroupLink} = navigationLinks;

const pgLogo = require("../images/property_group_logos/pg_logo.png");
const pgLogoMobile = require("../images/property_group_logos/pg_logo_mobile.png");
const rpLogo = require("../images/property_group_logos/rynek_pierwotny_mobile.png");
const rpLogoMobile = require("../images/property_group_logos/rynek_pierwotny.png");

export const HomepagePropertyGroupSection = () => {
    const {md} = useThemeNumericBreakpoints();

    return (
        <Container fluid as="section" className={sectionStyle}>
            <div className={contentStyle}>
                <div className={introStyle}>
                    <Text as="p" variant="headline_2" mb={4}>
                        Należymy do:
                    </Text>
                    <a href={propertyGroupLink} target="_blank" rel="noopener" aria-label="Property Group" className={css({display: "inline-flex", mb: 4})}>
                        <Picture
                            sources={[
                                {
                                    minWidthPX: 0,
                                    src: pgLogoMobile,
                                    width: 276,
                                    height: 64
                                },
                                {
                                    minWidthPX: md,
                                    src: pgLogo,
                                    width: 312,
                                    height: 72
                                }
                            ]}
                            alt="Property Group logo"
                            loading="lazy"
                        />
                    </a>
                    <Text variant="body_copy_0" color="var(--colors-gray-700)">
                        Wspólnie tworzymy ekosystem usług dla rynku nieruchomości
                    </Text>
                </div>
                <ul className={logosGridStyle}>
                    <li className={logoWrapper}>
                        <Picture
                            sources={[
                                {
                                    minWidthPX: 0,
                                    src: rpLogoMobile,
                                    width: 146,
                                    height: 45
                                },
                                {
                                    minWidthPX: md,
                                    src: rpLogo,
                                    width: 184,
                                    height: 57
                                }
                            ]}
                            alt={concatWithBrandName("", "logo").trim()}
                            loading="lazy"
                        />
                    </li>
                    {companyLogos.map((company) => (
                        <li key={company.name} className={logoWrapper}>
                            <a href={company.href} target="_blank" rel="noopener" aria-label={company.name} className={css({display: "inline-flex"})}>
                                <Picture
                                    sources={[
                                        {
                                            minWidthPX: 0,
                                            src: company.logoMobile,
                                            width: company.mobileWidth,
                                            height: company.mobileHeight
                                        },
                                        {
                                            minWidthPX: md,
                                            src: company.logoDesktop,
                                            width: company.width,
                                            height: company.height
                                        }
                                    ]}
                                    alt={`${company.name} logo`}
                                    loading="lazy"
                                />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </Container>
    );
};

const introStyle = css({
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    maxWidth: "320px"
});

const sectionStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--colors-white)"
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "var(--grid-lg-widthPx)",
    gap: 5,
    py: 5,
    px: 1.5,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        px: 3.5
    }
});

const logosGridStyle = css({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 4,
    margin: 0,
    padding: 0,
    listStyle: "none",

    md: {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 6
    }
});
const logoWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {useThemeNumericBreakpoints} from "@pg-design/themes";
import {navigationLinks} from "@pg-rp/navigation";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {companyLogos} from "../constants/company_logos";

const {propertyGroupLink} = navigationLinks;

const pgLogo = require("../images/property_group_logos/pg_logo.png");
const pgLogoMobile = require("../images/property_group_logos/pg_logo_mobile.png");
const rpLogo = require("../images/property_group_logos/rynek_pierwotny_mobile.png");
const rpLogoMobile = require("../images/property_group_logos/rynek_pierwotny.png");

export const HomepagePropertyGroupSection = () => {
    const {md} = useThemeNumericBreakpoints();

    return (
        <Container fluid as="section" className={sectionStyle}>
            <div className={contentStyle}>
                <div className={introStyle}>
                    <Text as="p" variant="headline_2" mb={4}>
                        Należymy do:
                    </Text>
                    <a href={propertyGroupLink} target="_blank" rel="noopener" aria-label="Property Group" className={css({display: "inline-flex", mb: 4})}>
                        <Picture
                            sources={[
                                {
                                    minWidthPX: 0,
                                    src: pgLogoMobile,
                                    width: 276,
                                    height: 64
                                },
                                {
                                    minWidthPX: md,
                                    src: pgLogo,
                                    width: 312,
                                    height: 72
                                }
                            ]}
                            alt="Property Group logo"
                            loading="lazy"
                        />
                    </a>
                    <Text variant="body_copy_0" color="var(--colors-gray-700)">
                        Wspólnie tworzymy ekosystem usług dla rynku nieruchomości
                    </Text>
                </div>
                <ul className={logosGridStyle}>
                    <li className={logoWrapper}>
                        <Picture
                            sources={[
                                {
                                    minWidthPX: 0,
                                    src: rpLogoMobile,
                                    width: 146,
                                    height: 45
                                },
                                {
                                    minWidthPX: md,
                                    src: rpLogo,
                                    width: 184,
                                    height: 57
                                }
                            ]}
                            alt={concatWithBrandName("", "logo").trim()}
                            loading="lazy"
                        />
                    </li>
                    {companyLogos.map((company) => (
                        <li key={company.name} className={logoWrapper}>
                            <a href={company.href} target="_blank" rel="noopener" aria-label={company.name} className={css({display: "inline-flex"})}>
                                <Picture
                                    sources={[
                                        {
                                            minWidthPX: 0,
                                            src: company.logoMobile,
                                            width: company.mobileWidth,
                                            height: company.mobileHeight
                                        },
                                        {
                                            minWidthPX: md,
                                            src: company.logoDesktop,
                                            width: company.width,
                                            height: company.height
                                        }
                                    ]}
                                    alt={`${company.name} logo`}
                                    loading="lazy"
                                />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </Container>
    );
};

const introStyle = css({
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    maxWidth: "320px"
});

const sectionStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--colors-white)"
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "var(--grid-lg-widthPx)",
    gap: 5,
    py: 5,
    px: 1.5,

    md: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        px: 3.5
    }
});

const logosGridStyle = css({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: 4,
    margin: 0,
    padding: 0,
    listStyle: "none",

    md: {
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 6
    }
});
const logoWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
